// ─── Petrix channel labels ────────────────────────────────────────────────────
// One canonical name per Petrix telemetry channel.
//
// This existed in three hand-maintained copies before: channelNameDictionary in
// TreatmentDataGraph, and PETRIX_BASE_CHANNELS + CHANNEL_LABELS in
// RulesManagementModal (which duplicated each other inside one file). They had
// already drifted — 'step' read "Step Number" on the chart and "Step" in the
// rules UI; 'sand_design_percentage' read "Sand Design %" in both TS files but
// "Sand Design Percentage" in poster-worker-db.py.
//
// Canonical values below follow the majority reading, so adopting this changes
// exactly one visible label: the chart's channel picker shows "Step" instead of
// "Step Number".
//
// poster-worker-db.py keeps its own Python copy — it cannot import TS. Its
// labels only surface in the "changes" text Petrix displays, so drift there is
// cosmetic, but 'sand_design_percentage' is worth aligning by hand.

// Numeric 1 Hz channels — plottable, and valid as rule trigger sources.
export const TREATMENT_CHANNEL_LABELS: Record<string, string> = {
  step:                   'Step',
  treat_press:            'Treating Pressure',
  clean_rate:             'Clean Rate',
  slurry_rate:            'Slurry Rate',
  stage_denso:            'Stage Density',
  elapsed_time:           'Elapsed Time',
  step_clean:             'Step Clean',
  step_slurry:            'Step Slurry',
  step_sand:              'Step Sand',
  net_pressure:           'Net Pressure',
  stage_slurry:           'Stage Slurry',
  clean_rate_calc:        'Clean Rate Calculated',
  stage_sand:             'Stage Sand',
  sand_design_percentage: 'Sand Design %',
  friction_loss_press:    'Friction Loss Pressure',
  stp_b:                  'STP B',
  hydrostatic_press:      'Hydrostatic Pressure',
  stage_clean:            'Stage Clean',
  bhp:                    'Bottom Hole Pressure',
};

// Non-numeric channels. Available to the rules UI but never charted, which is
// why they are held apart from TREATMENT_CHANNEL_LABELS rather than mixed in.
export const NON_NUMERIC_CHANNEL_LABELS: Record<string, string> = {
  step_name: 'Step Name',
};

export const PETRIX_CHANNEL_LABELS: Record<string, string> = {
  ...TREATMENT_CHANNEL_LABELS,
  ...NON_NUMERIC_CHANNEL_LABELS,
};

// Plottable channel keys — what TreatmentDataGraph offers in Chart Settings.
export const TREATMENT_CHANNELS = Object.keys(TREATMENT_CHANNEL_LABELS);

// { value, label } options for react-select. Ordered step, step_name, then the
// rest, matching how the rules action picker reads today.
export const PETRIX_CHANNEL_OPTIONS = [
  { value: 'step',      label: PETRIX_CHANNEL_LABELS.step },
  { value: 'step_name', label: PETRIX_CHANNEL_LABELS.step_name },
  ...Object.entries(PETRIX_CHANNEL_LABELS)
    .filter(([k]) => k !== 'step' && k !== 'step_name')
    .map(([value, label]) => ({ value, label })),
];
